import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

const LoginErrorModal = ({
  visible,
  onClose,
  errorMessage,
}) => {
  if (!visible) {
    return null
  }

  // The gray page background
  const backdropStyle = {
    backgroundColor: 'rgba(0,0,0,0.5)',
    bottom: 0,
    left: 0,
    position: 'fixed',
    right: 0,
    top: 0,
    zIndex: 1000,
  }

  const popupStyle = {
    backgroundColor: 'white',
    borderRadius: '10px',
    color: '#D00000',
    fontSize: '1.2em',
    padding: '20px',
    position: 'fixed',
    top: '50%',
    left: '50%',
    width: '320px',
    maxWidth: '90%',
    zIndex: 1001,
    transform: 'translate(-50%, -50%)',
    boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
  }

  const titleStyle = {
    fontSize: '1.4em',
    textAlign: 'center',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    marginBottom: '15px',
    color: '#D00000',
  }

  const messageStyle = {
    textAlign: 'center',
    marginBottom: '25px',
    lineHeight: '1.4',
    color: '#333',
  }

  const buttonStyle = {
    border: 'none',
    fontSize: '1em',
    padding: '12px 24px',
    borderRadius: '5px',
    cursor: 'pointer',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    width: '100%',
  }

  const okButtonStyle = {
    ...buttonStyle,
    backgroundColor: '#D00000',
    color: 'white',
  }

  return (
    <div style={backdropStyle} onClick={onClose}>
      <div style={popupStyle} onClick={(e) => e.stopPropagation()}>
        <div style={titleStyle}>
          <FormattedMessage
            id='login.error.title'
            defaultMessage='Login Error'
            description='Login error modal title'
          />
        </div>
        <div style={messageStyle}>
          {errorMessage || (
            <FormattedMessage
              id='login.error.default'
              defaultMessage='Invalid email or password. Please try again.'
              description='Default login error message'
            />
          )}
        </div>
        <button
          style={okButtonStyle}
          type='button'
          onClick={onClose}
        >
          <FormattedMessage
            id='login.error.ok'
            defaultMessage='OK'
            description='OK button for login error modal'
          />
        </button>
      </div>
    </div>
  )
}

LoginErrorModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
}

export default LoginErrorModal
